import PageHeader from "@/components/PageHeader";
import Reveal from "@/components/Reveal";
import { ButtonSecondary } from "@/components/Buttons";

const SECTIONS = [
    {
        title: "Scope of this policy",
        text: "This policy applies to every material supplied by Grayhaven Research and to all information published on this website. It exists so that materials are used responsibly and so that visitors understand exactly what our materials are — and what they are not.",
    },
    {
        title: "Permitted use",
        text: "Grayhaven materials are supplied strictly for legitimate laboratory research purposes, handled by qualified adults in appropriate research settings, in accordance with all applicable laws and regulations.",
    },
    {
        title: "Prohibited use",
        text: "Our materials are not intended for human or veterinary use of any kind. This includes consumption, administration, diagnosis, treatment, or prevention of disease. Nothing on this website constitutes medical advice, dosing guidance, or a therapeutic claim.",
    },
    {
        title: "Age requirement",
        text: "This website and its catalog are intended for visitors aged 21 or older. Entry to the website requires an affirmative confirmation of age and acceptance of this policy.",
    },
    {
        title: "Documentation",
        text: "Independent testing results and Certificates of Analysis are maintained for the materials we supply and are available as described on our Testing & Documentation page. Documentation relates to the identity and purity of research materials and does not imply suitability for any non-research purpose.",
    },
];

export default function ResearchUse() {
    return (
        <div data-testid="research-use-page">
            <PageHeader
                eyebrow="Policy"
                title="Research Use Policy"
                description="The terms under which Grayhaven Research materials are supplied and this website is provided."
            />
            <section className="pb-24 sm:pb-32 px-6 lg:px-8">
                <div className="max-w-3xl mx-auto">
                    {SECTIONS.map((section, i) => (
                        <Reveal key={section.title} delay={Math.min(i * 0.05, 0.2)}>
                            <div className="py-8 border-b border-stone-200">
                                <h2 className="font-serif text-2xl font-light text-brand">{section.title}</h2>
                                <p className="mt-4 text-sm leading-relaxed text-mist">{section.text}</p>
                            </div>
                        </Reveal>
                    ))}
                    <Reveal className="mt-14 text-center">
                        <p className="text-sm text-mist">Questions about this policy?</p>
                        <div className="mt-6">
                            <ButtonSecondary to="/contact" data-testid="research-use-contact-btn">
                                Contact Grayhaven
                            </ButtonSecondary>
                        </div>
                    </Reveal>
                </div>
            </section>
        </div>
    );
}
